import { createSlice } from '@reduxjs/toolkit';

const toastSlice = createSlice({
  name: 'toast',
  initialState: {
    message: "",
    show:false,
    type:""
  },
  reducers: {
    showToast: (state, action) => {
      const { message, type } = action.payload;
      state.show = true;
      state.message = message;
      state.type = type;
    },
    hideToast: (state) => {
      state.show = false; 
    },
    
  },
});

export const { showToast, hideToast } = toastSlice.actions;
export default toastSlice.reducer;